import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import tourPackagesService, { TOUR_PACKAGE_STATUS } from 'services/admin/tour-packages.service';

export default function TourpackageAutocompleteField({ label, setValue }) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let active = true;

        // Skip empty input
        // if (inputValue.trim() === '') {
        //     setOptions([]);
        //     return undefined;
        // }

        // Debounce API requests
        const timer = setTimeout(async () => {
            setLoading(true);
            try {
                const res = await tourPackagesService.getAll({ query: inputValue, limit: 100, status: TOUR_PACKAGE_STATUS.PUBLISHED });
                console.log(`res:`, res);
                if (active) {
                    const tourPackages = res.data.data.map(tp => ({
                        ...tp,
                        name: `${tp.name} - ${tp.startDate}`
                    }));
                    setOptions(tourPackages);
                }
            } catch (err) {
                console.error(err);
            } finally {
                if (active) setLoading(false);
            }
        }, 400);

        return () => {
            active = false;
            clearTimeout(timer);
        };
    }, [inputValue]);

    return (
        <Autocomplete
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            getOptionLabel={(option) => option.name}
            options={options}
            loading={loading}
            onInputChange={(event, value) => setInputValue(value)}
            onChange={(event, value) => setValue(value)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}
